import React, { useState, useEffect } from 'react';
import styles from './Guide.module.css';

const FormDynamicRenderer = ({ methodId, detailLevel, formData, onFormDataChange }) => {
  const [sections, setSections] = useState([]);

  useEffect(() => {
    import(`./forms/${methodId}/${detailLevel}.js`).then((module) => {
      setSections(module.default);
    });
  }, [methodId, detailLevel]);

  const handleChange = (id, value) => {
    onFormDataChange({ ...formData, [id]: value });
  };

  return (
    <div className={styles['form-dynamic-renderer']}>
      <h2>
        Méthode {methodId.toUpperCase()} – Niveau {detailLevel.charAt(0).toUpperCase() + detailLevel.slice(1)}
      </h2>
      <form>
        {Array.isArray(sections) && sections.map((section, idx) => (
          <div key={idx} className={styles['form-section']}>
            <h3>{section.title}</h3>
            {section.description && section.description.split('\n').map((line, i) => (
              <p key={i} className={styles['section-description']}>{line}</p>
            ))}

            {section.fields.map((field) => (
              <div key={field.id} className={styles['form-group']}>
                <label htmlFor={field.id}>{field.label}</label>
                {field.type === 'textarea' ? (
                  <textarea
                    id={field.id}
                    value={formData[field.id] || ''}
                    onChange={(e) => handleChange(field.id, e.target.value)}
                  />
                ) : (
                  <input
                    type="text"
                    id={field.id}
                    value={formData[field.id] || ''}
                    onChange={(e) => handleChange(field.id, e.target.value)}
                  />
                )}
              </div>
            ))}
          </div>
        ))}
      </form>
    </div>
  );
};

export default FormDynamicRenderer;
